import httpClient from './httpClient'

class AssetApi {
  static async createAssets(advertiserId, file) {
    const form = new FormData()
    form.append('file', file)
    const res = await httpClient.post(
      `/media_asset?advertiser=${advertiserId}`,
      form,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    return res.data.item
  }

  static async getAsset(id) {
    try {
      const res = await httpClient.get(`/media_asset/${id}`)
      return res.data.item
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}

export default AssetApi
